import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect, useLayoutEffect } from 'react';

type AutofocusPluginProps = {
    disabled: boolean;
};

function AutofocusPlugin({ disabled }: AutofocusPluginProps): JSX.Element | null {
    const [editor] = useLexicalComposerContext();

    useLayoutEffect(() => {
        if (!disabled) {
            editor.focus();
        }
    }, [disabled, editor]);

    useEffect(() => {
        if (!disabled) {
            editor.focus();
        }
    }, [editor, disabled]);

    return null;
}

export default AutofocusPlugin;
